import { Toggle } from '@bitcine/cinesend-theme/dist'
import { useState } from 'react'
import { Lock } from '../icons'

const IsSizeField = ({ field, saveField }) => {
  const [isSizeField, setIsSizeField] = useState(field.is_size_field)
  const isLocked = field?.uneditable_when_locked_attributes?.includes('is_size_field') ?? false
  return (
    <>
      <Toggle
        className='space-x-4'
        checked={isSizeField}
        label='Size field'
        onChange={() => {
          setIsSizeField(!isSizeField)
          saveField({ is_size_field: !isSizeField })
        }}
        disabled={isLocked}
      />
      {isLocked && <Lock />}
    </>
  )
}

export default IsSizeField
